package fr.manyverse.app.infrastructure.repository

import fr.manyverse.app.domain.model.UserConfig
import fr.manyverse.app.domain.repository.UserConfigRepository
import fr.manyverse.app.infrastructure.cache.UserConfigCache
import fr.manyverse.app.infrastructure.datastore.UserPreferencesDataStore
import kotlin.time.Instant

class CachingUserConfigRepository(
    private val remote: SupabaseUserConfigRepository,
    private val memCache: UserConfigCache,
    private val dataStore: UserPreferencesDataStore
) : UserConfigRepository {

    override suspend fun getUserConfig(userId: String): Result<UserConfig?> {
        if (memCache.isAccepted(userId)) {
            return Result.success(UserConfig(userId, Instant.DISTANT_PAST))
        }
        if (dataStore.isTermsAccepted(userId)) {
            memCache.markAccepted(userId)
            return Result.success(UserConfig(userId, Instant.DISTANT_PAST))
        }
        return remote.getUserConfig(userId).onSuccess { config ->
            if (config?.hasAcceptedTerms == true) {
                memCache.markAccepted(userId)
                dataStore.saveTermsAccepted(userId)
            }
        }
    }

    override suspend fun upsertTermsAcceptance(userId: String): Result<Unit> =
        remote.upsertTermsAcceptance(userId).onSuccess {
            memCache.markAccepted(userId)
            dataStore.saveTermsAccepted(userId)
        }
}
